module.exports = __webpack_public_path__ + "static/media/logo-dekton.13de03c7.svg";